import HardcodedSalesDemoPath from '../data/hardcodedSalesDemoPath';
import ForensicWatermarkingSvg from '../media/hexagonIconImage/icons/ForensicWatermarking_Plain.svg';
import AboutUsSvg from '../media/hexagonIconImage/icons/about_us.svg';
import AdsSvg from '../media/hexagonIconImage/icons/ads.svg';
import AiEncodingSvg from '../media/hexagonIconImage/icons/ai_encoding.svg';
import AnalyticsSvg from '../media/hexagonIconImage/icons/analytics.svg';
import BehavioralPlaybackSvg from '../media/hexagonIconImage/icons/behavioural_playback.svg';
import ChunkBased3PassEncodingSvg from '../media/hexagonIconImage/icons/chunk_based_3_pass_encoding.svg';
import CmafLowLatencySvg from '../media/hexagonIconImage/icons/cmaf_low_latency.svg';
import CswSvg from '../media/hexagonIconImage/icons/csw.svg';
import CustomizableUiSvg from '../media/hexagonIconImage/icons/customizable_ui.svg';
import DolbyVisionSvg from '../media/hexagonIconImage/icons/dolby_vision.svg';
import DrmSvg from '../media/hexagonIconImage/icons/drm.svg';
import EncodingThinSvg from '../media/hexagonIconImage/icons/encoding-thin.svg';
import EncodingAwsSvg from '../media/hexagonIconImage/icons/encoding_aws.svg';
import EncodingGoogleCloudSvg from '../media/hexagonIconImage/icons/encoding_google_cloud.svg';
import LiveStreamingSvg from '../media/hexagonIconImage/icons/live_streaming.svg';
import LiveStreamingSRTSvg from '../media/hexagonIconImage/icons/live_streaming_srt.svg';
import LiveStreamingZixiSvg from '../media/hexagonIconImage/icons/live_streaming_zixi.svg';
import MobileSdksSvg from '../media/hexagonIconImage/icons/mobile_sdks.svg';
import ModularPLayerSvg from '../media/hexagonIconImage/icons/modular_player.svg';
import MultiCodecSvg from '../media/hexagonIconImage/icons/multi_codec.svg';
import OfflinePlaybackSvg from '../media/hexagonIconImage/icons/offline_playback.svg';
import PlayerAnalyticsBundlingSvg from '../media/hexagonIconImage/icons/player_analytics_bundling.svg';
import ServerSideAdInsertionSvg from '../media/hexagonIconImage/icons/server_side_ad_insertion.svg';
import SsaiBroadpeak from '../media/hexagonIconImage/icons/ssai_broadpeak.svg';
import SsaiGoogleDFPSvg from '../media/hexagonIconImage/icons/ssai_google_dfp.svg';
import SsaiMediaTaylorSvg from '../media/hexagonIconImage/icons/ssai_mediaTaylor.svg';
import SsaiYoSpaceSvg from '../media/hexagonIconImage/icons/ssai_yospace.svg';
import Vr360Svg from '../media/hexagonIconImage/icons/vr_360.svg';
import VvcSvg from '../media/hexagonIconImage/icons/vvc.svg';
import AwsLogoSvg from '../media/partnerIcons/aws.svg';
import AwsHexagonLabelSvg from '../media/partnerIcons/aws_hexagon_label.svg';
import DolbySvg from '../media/partnerIcons/dolby.svg';
import GoogleCloudLogoSvg from '../media/partnerIcons/google_cloud.svg';
import GoogleDFPHexagonLabelSvg from '../media/partnerIcons/google_dfp_hexagon_label.svg';
import SRTLogoSvg from '../media/partnerIcons/srt.png';
import SRTHexagonLabelSvg from '../media/partnerIcons/srt_hexagon_label.png';
import YospaceLogoSvg from '../media/partnerIcons/yospace.svg';
import YospaceHexagonLabelSvg from '../media/partnerIcons/yospace_hexagon_label.svg';
import ZixiLogoSvg from '../media/partnerIcons/zixi.svg';
import ZixiHexagonLabelSvg from '../media/partnerIcons/zixi_hexagon_label.svg';

class SalesDemoIconPathRegistry {
  private constructor() {}

  public static getIconPath(salesDemoPath: string): string {
    switch (salesDemoPath) {
      case HardcodedSalesDemoPath.Ads:
        return AdsSvg;
      case HardcodedSalesDemoPath.Vvc:
        return VvcSvg;
      case HardcodedSalesDemoPath.AnalyticsBitrateDemo:
        return AnalyticsSvg;
      case HardcodedSalesDemoPath.BehavioralPlayback:
        return BehavioralPlaybackSvg;
      case HardcodedSalesDemoPath.ChunkBased3PassEncoding:
        return AiEncodingSvg;
      case HardcodedSalesDemoPath.CloudEncodingAws:
        return EncodingAwsSvg;
      case HardcodedSalesDemoPath.CloudEncodingDemo:
        return EncodingThinSvg;
      case HardcodedSalesDemoPath.CloudEncodingGc:
        return EncodingGoogleCloudSvg;
      case HardcodedSalesDemoPath.CustomizableUi:
        return CustomizableUiSvg;
      case HardcodedSalesDemoPath.Drm:
        return DrmSvg;
      case HardcodedSalesDemoPath.DolbyVision:
        return DolbyVisionSvg;
      case HardcodedSalesDemoPath.ForensicWatermarking:
        return ForensicWatermarkingSvg;
      case HardcodedSalesDemoPath.GrassValley:
        return LiveStreamingSvg;
      case HardcodedSalesDemoPath.LiveStreaming:
        return LiveStreamingSvg;
      case HardcodedSalesDemoPath.LiveStreamingSRT:
        return LiveStreamingSRTSvg;
      case HardcodedSalesDemoPath.LiveStreamingZixi:
        return LiveStreamingZixiSvg;
      case HardcodedSalesDemoPath.LowLatencyStreaming:
        return CmafLowLatencySvg;
      case HardcodedSalesDemoPath.ModularPlayer:
        return ModularPLayerSvg;
      case HardcodedSalesDemoPath.Multicodec:
        return MultiCodecSvg;
      case HardcodedSalesDemoPath.NativeSdks:
        return MobileSdksSvg;
      case HardcodedSalesDemoPath.OfflinePlayback:
        return OfflinePlaybackSvg;
      case HardcodedSalesDemoPath.OnPremiseEncodingDemo:
        return EncodingThinSvg;
      case HardcodedSalesDemoPath.PlayerAnalyticsBundling:
        return PlayerAnalyticsBundlingSvg;
      case HardcodedSalesDemoPath.Ssai:
        return ServerSideAdInsertionSvg;
      case HardcodedSalesDemoPath.SsaiYospace:
        return SsaiYoSpaceSvg;
      case HardcodedSalesDemoPath.SsaiMediaTaylor:
        return SsaiMediaTaylorSvg;
      case HardcodedSalesDemoPath.SsaiGoogleDFP:
        return SsaiGoogleDFPSvg;
      case HardcodedSalesDemoPath.Csw:
        return CswSvg;
      case HardcodedSalesDemoPath.ThreePassEncoding:
        return ChunkBased3PassEncodingSvg;
      case HardcodedSalesDemoPath.VrPlayer:
        return Vr360Svg;
      case HardcodedSalesDemoPath.Videon:
        return LiveStreamingSvg;
      case HardcodedSalesDemoPath.SsaiBroadpeak:
        return SsaiBroadpeak;

      default:
        return AboutUsSvg;
    }
  }

  public static getPartnerLogoIconPath(salesDemoPath: string) {
    switch (salesDemoPath) {
      case HardcodedSalesDemoPath.CloudEncodingAws:
        return AwsLogoSvg;
      case HardcodedSalesDemoPath.CloudEncodingGc:
        return GoogleCloudLogoSvg;
      case HardcodedSalesDemoPath.DolbyVision:
        return DolbySvg;
      case HardcodedSalesDemoPath.LiveStreamingSRT:
        return SRTLogoSvg;
      case HardcodedSalesDemoPath.LiveStreamingZixi:
        return ZixiLogoSvg;
      case HardcodedSalesDemoPath.SsaiGoogleDFP:
        return GoogleDFPHexagonLabelSvg;
      case HardcodedSalesDemoPath.SsaiMediaTaylor:
        return AwsLogoSvg;
      case HardcodedSalesDemoPath.SsaiYospace:
        return YospaceLogoSvg;

      default:
        return undefined;
    }
  }

  public static getPartnerHexagonLabelIconPath(salesDemoPath: string) {
    switch (salesDemoPath) {
      case HardcodedSalesDemoPath.LiveStreamingSRT:
        return SRTHexagonLabelSvg;
      case HardcodedSalesDemoPath.LiveStreamingZixi:
        return ZixiHexagonLabelSvg;
      case HardcodedSalesDemoPath.SsaiGoogleDFP:
        return GoogleDFPHexagonLabelSvg;
      case HardcodedSalesDemoPath.SsaiMediaTaylor:
        return AwsHexagonLabelSvg;
      case HardcodedSalesDemoPath.SsaiYospace:
        return YospaceHexagonLabelSvg;

      default:
        return undefined;
    }
  }
}

export default SalesDemoIconPathRegistry;
